export const defaultTransitionTime = "0.3s";
